import { SessionsTableMoreOptionsMenu } from 'features/sessions/components/Table/MoreOptions/SessionsTableMoreOptionsMenu';
import { SessionsTableRowDataType } from 'features/sessions/config/types';

type SessionsTableMoreOptionsCellProps = {
  value: string;
  row: SessionsTableRowDataType;
};

export const SessionsTableMoreOptionsCell = ({
  value: sessionId,
  row,
}: SessionsTableMoreOptionsCellProps) => {
  const { original } = row;
  const { startAt, endAt } = original;

  return (
    <SessionsTableMoreOptionsMenu
      attendance={row.original.attendance}
      sessionId={sessionId}
      sessionStartAt={startAt}
      sessionEndAt={endAt}
    />
  );
};
